"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../icon/Icon"));
var _tooltip = require("../../tooltip");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ICON_SIZE = 10;
var StyledTooltipError = _styledComponents["default"].div.withConfig({
  displayName: "TooltipError__StyledTooltipError",
  componentId: "sc-9avb8p-0"
})(["", ";"], function (_ref) {
  var theme = _ref.theme;
  var color = theme.palette,
    spacing = theme.spacing,
    genericBorderRadius = theme.extra.genericBorderRadius;
  return (0, _styledComponents.css)(["cursor:pointer;width:", ";height:", ";background-color:", ";text-align:center;border-radius:50%;display:flex;align-items:center;justify-content:center;position:absolute;right:", ";top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);color:white;z-index:2;@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){top:0;bottom:0;margin:auto;}.main-tooltip.styled-tooltip{border-radius:", ";background-color:white;border:1px solid ", ";color:", ";&:after{content:'';border-left-color:", ";}}"], spacing.small, spacing.small, color.validation.error, spacing.tiny, genericBorderRadius, color.validation.error, color.validation.error, color.validation.error);
});
var TooltipError = function TooltipError(_ref2) {
  var error = _ref2.error,
    id = _ref2.id;
  return /*#__PURE__*/_react["default"].createElement(StyledTooltipError, {
    className: "tooltip-container error",
    "data-tip": error,
    "data-place": "left",
    "data-for": "tip-".concat(id)
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-alert",
    size: ICON_SIZE
  }), /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "tip-".concat(id)
  }));
};
TooltipError.propTypes = {
  id: _propTypes["default"].string.isRequired,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired
};
TooltipError.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TooltipError",
  "props": {
    "id": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "error": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": true
    }
  }
};
var _default = TooltipError;
exports["default"] = _default;